import React, { useState } from "react";
import useScrollReset from "@hooks/ScrollHook";
import { CustomDropdown } from "@components/dropdown/CustomDropdown";
import { useAccount } from "@contexts/AccountContext";
import { useSelectedChain } from "@app/examples/ChainSelector";
import { useApi } from "@hooks/ApiHook";
import { CollectionDropdownItem } from "@components/dropdown/CollectionDropdownItem";
import useAlert from "@hooks/AlertHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "@hooks/QueryParamsHook";
import ItemDirectoryPicker from "@components/item/ItemDirectoryPicker";
import { ItemResponse } from "baaanggg";
import { PaginationBar } from "@components/PaginationBar";
import { PreviewItemCard } from "@components/item/PreviewItemCard";

function BulkCreateItemPage() {
    useScrollReset()

    const { collectionId } = useQueryParams();
    const navigate = useNavigate()
    const alert = useAlert()
    const baaangggg = useBaaanggg()
    const { address } = useAccount()
    const { selectedChain } = useSelectedChain()
    const { data: collections } = useApi(api => api.collection.simple({ chainId: selectedChain?.id, ownerAddress: address }), [address, selectedChain])

    const [collection, setCollection] = useState<string | undefined>(collectionId ?? undefined)
    const [items, setItems] = useState<ItemResponse[]>()
    const [files, setFiles] = useState<File[]>()
    const [page, setPage] = useState(1)

    const onItemsPick = async (files: Map<string, { json: File, image: File }>) => {
        setFiles(Array.from(files.values()).reduce((prev, curr) => [...prev, curr.image, curr.json] as any, []))

        const items: ItemResponse[] = []

        const keys = Array.from(files.keys()).sort().reverse()
        for (const id of keys) {
            const { image, json } = files.get(id)!
            const i = keys.indexOf(id) + 1
            try {
                alert.loading(`Load files: ${(i / keys.length * 100).toFixed(2)}%`)
                items.push(await readFileAsync(id, json, image))
            } catch { }
        }
        alert.hide()
        setItems(items)
    }

    const readFileAsync = (id: string, json: File, image: File) => {
        return new Promise<any>((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const fileContent = e.target!.result;
                try {
                    let object = undefined;
                    if (typeof fileContent === "string") object = JSON.parse(fileContent)
                    else if (fileContent instanceof ArrayBuffer) object = JSON.parse(Buffer.from(fileContent).toString("utf-8"))

                    if (object) {
                        if (!('name' in object)) throw null;
                        resolve({
                            id,
                            image: URL.createObjectURL(image),
                            collectionId: collection ?? id,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                            name: object['name'],
                            supply: object['supply'] ?? 1
                        })

                    } else throw null;
                } catch (e) {
                    reject(e)
                }
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsText(json);
        });
    };

    const onSubmit = async () => {
        try {
            if (!collection) throw new Error("Collection must be selected")
            if (!files) throw new Error("Files not selected")
            alert.loading(`Creating item: 0%`)

            const chunkedFiles = [];
            const size = 100;
            for (let i = 0; i < files.length; i += size) {
                const chunk = files.slice(i, i + size);
                chunkedFiles.push(chunk);
            }

            let uploadedCount = 0;

            for (const part of chunkedFiles) {
                try {
                    const { cid } = await baaangggg.item.bulk({
                        collectionId: collection,
                        files: part
                    })
                    await baaangggg.item.storeFromCID({
                        cid: cid,
                        collectionId: collection
                    })
                    uploadedCount += part.length;
                    alert.loading(`Creating item: ${(uploadedCount / files.length * 100).toFixed(2)}%`)
                } catch { }
            }

            alert.success(`${uploadedCount} items created`)
        } catch (e) {
            if (e instanceof Error) alert.failed(`Cannot create item, reason: ${e.message}`)
            else console.log(e)
        }
    }

    return <>
        <main>
            <section className="relative py-24">
                <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                    <img src="img/gradient_light.jpg"
                        alt="gradient"
                        className="h-full w-full" />
                </picture>
                <div className="container">
                    <h1 className="py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-jacarta-500">Bulk Create NFT</h1>

                    <div className="mx-auto max-w-[48.125rem]">
                        <ItemDirectoryPicker onChange={onItemsPick} />

                        {
                            collections && <div className="mb-6">
                                <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Collection</label>
                                <CustomDropdown
                                    value={collection}
                                    onSelected={item => setCollection(item?.id)}
                                    builder={(collection, isSelected) => <CollectionDropdownItem
                                        isSelected={isSelected}
                                        collection={collection} />}
                                    format={item => item.name}
                                    items={collections} />
                            </div>
                        }

                        {
                            items && <div className="mb-6">
                                <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Previews</label>
                                <div className="grid grid-cols-1 gap-[1rem] md:grid-cols-3 lg:grid-cols-4">
                                    {
                                        items?.slice((page - 1) * 20, (page - 1) * 20 + 20).map(item => <PreviewItemCard key={item.id} item={item} />)
                                    }
                                </div>

                                <div className="mt-5"></div>

                                {
                                    items && <PaginationBar
                                        pagination={{
                                            page,
                                            totalCount: items.length,
                                            totalPage: Math.ceil(items.length / 20)
                                        }}
                                        currentPage={page}
                                        onPageChange={page => setPage(page)} />
                                }
                            </div>
                        }


                        <button
                            onClick={onSubmit}
                            className="rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
                            Create
                        </button>
                    </div>
                </div>
            </section>
        </main>
    </>
}

export default BulkCreateItemPage;